import { abtestActivate } from 'JIX/abtest/api.js';
import { compareResponsiveBreakpoint } from 'JIX/utils/breakpoints.js';

const stash = window.Stash['recommended_jobs'];

const { abtestids } = stash;

if (Object.keys(abtestids).length > 0) {
    const observerOptions = {
        root: null, // null = viewport
        rootMargin: '0px',
        threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries, observer) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                const context = compareResponsiveBreakpoint('sm') <= 0 ? 'mobile' : 'desktop';
                Object.values(abtestids).forEach(abtestid => abtestActivate(abtestid, context));
                observer.unobserve(entry.target);
            }
        }
    }, observerOptions);

    const container = document.getElementById('recommended-jobs');
    if (container) {
        observer.observe(container);
        container.querySelectorAll('.job-card').forEach(card => {
            const tid = card.dataset.tid;
            if (tid && abtestids[tid]) {
                card.querySelectorAll('a').forEach(link => {
                    const url = new URL(link.href);
                    url.searchParams.set('abtestid', abtestids[tid]);
                    link.href = url;
                });
            }
        });
    }
}
